/**
 * @author Fernando FH
 */

 import PRM from "@/core/PermissionConstants";
 import  RouteConstants from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.TELEMEDICINE_PENDING.path,
  name: RouteConstants.TELEMEDICINE_PENDING.name,
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/TelemedicinePendingService"),
    table: () => import("@/app/components/telemedicine/pending/TelemedicinePendingTable"),
    form: () => import("@/app/components/telemedicine/pending/TelemedicinePendingForm"),

    header: {
      icono: "mdi-monitor-dashboard",
      texto: "Pendientes | Telemedicina",
      textNew: "Atender | Telemedicina",
      textEdit: "Editar | Telemedicina",
      textView: "Visualizar | Telemedicina"
    },
    prm: PRM.MODULE_TELEMEDICINE_PAGINATION_PENDING,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    saveButton: "Finalizar",
    labelDate: "Seleccione fecha",
    namePDF: "Telemedicine",
    module: "telemedicina"
  },
};
